import { __assign, __rest } from 'tslib';
import MuiButton, { buttonClasses } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import React from 'react';

var getLoadingStyles = function (_a) {
    var theme = _a.theme, loading = _a.loading;
    return (__assign({ transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shortest,
        }) }, (loading && {
        opacity: 0,
    })));
};
var ButtonRoot = styled(MuiButton, {
    shouldForwardProp: function (propName) { return propName !== 'loading'; },
})(function (props) {
    var _a;
    return (_a = {},
        _a["& .".concat(buttonClasses.startIcon, ", & .").concat(buttonClasses.endIcon)] = getLoadingStyles(props),
        _a);
});
var Content = styled('span', {
    shouldForwardProp: function (propName) { return propName !== 'loading'; },
})(getLoadingStyles);
var ProgressWrapper = styled('div')({
    position: 'absolute',
    height: '100%',
    aspectRatio: '1 / 1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
});
var Button = React.forwardRef(function Button(_a, ref) {
    var children = _a.children, _b = _a.loading, loading = _b === void 0 ? false : _b, restProps = __rest(_a, ["children", "loading"]);
    return (React.createElement(ButtonRoot, __assign({}, restProps, { loading: loading, ref: ref }),
        React.createElement(Content, { loading: loading }, children),
        loading && (React.createElement(ProgressWrapper, null,
            React.createElement(CircularProgress, { color: "inherit", size: "65%" })))));
});

export { Button as default };
